import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
const SkeletonQuotationListing = ({ rows = 5 }) => {
  return (
    <div className='row order-table-row row-height mb-1'>
      <div className='col-12'>
        <div className='card mt-0 order-list-card'>
          <div className="card-body mb-2">
            <div className="table-responsive">
              <table className="table table-borderless table-list order-table-list">
                <thead>
                  <tr>
                    <th><div>PROJECT</div></th>
                    <th><div>ORDER REF</div></th>
                    <th><div>CUSTOMER</div></th>
                    <th><div>DISTRIBUTOR</div></th>
                    <th><div>COUNTRY</div></th>
                    <th><div>ORDER VALUE</div></th>
                    <th><div>CURRENCY</div></th>
                    <th><div>ORDER TYPE</div></th>
                    <th><div>ACTIONS</div></th>
                  </tr>
                </thead>

                <tbody>
                  {Array.from({ length: rows }).map((_, index) => (
                    <tr key={index}>
                      <td className='clickable-cell'>
                        <div className='project-cell'>
                          <div className='mr-2'>
                            <Skeleton width={32} height={15} />
                          </div>
                          <h5>
                            <Skeleton width={233} height={15} />
                          </h5>
                        </div>
                      </td>
                      <td><Skeleton width={104} height={15} /></td>
                      <td><Skeleton width={122} height={15} /></td>
                      <td><Skeleton width={120} height={15} /></td>
                      <td><Skeleton width={50} height={15} /></td>
                      <td><Skeleton width={50} height={15} /></td>
                      <td><Skeleton width={60} height={15} /></td>
                      <td><Skeleton width={64} height={15} /></td>
                      <td className='text-center'>
                        <Skeleton width={20} height={15} />
                      </td>
                    </tr>
                  ))}
                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonQuotationListing;